/* ============================================================================
FILE: po-k1-quiz-portal-fr-en-es-20260321.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK1QuizPortalFR_EN_ES_20260321
ROOT: .po-k1-hub-section[data-po-k1-hub="quiz_portal"]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K1_QUIZ_PORTAL_20260321__) return;
  window.__PO_K1_QUIZ_PORTAL_20260321__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k1-hub-section[data-po-k1-hub="quiz_portal"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));
    return out;
  }

  function getSimplifiedLexiqueFRList() {
    var merged = [];
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        for (var i = 0; i < window.PO_LEXICON_META.lexique_simplifie_fr.length; i++) {
          uniqPush(merged, window.PO_LEXICON_META.lexique_simplifie_fr[i]);
        }
      }
    } catch (e) {}

    [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Axis",
      "Organon posœnnoïal",
      "Katûvýs",
      "Katûvýsissence",
      "RéZonans",
      "Péroptissimisme",
      "Aliœvolution",
      "Illusion",
      "Addition synchrêtique",
      "Superposition de perspectives",
      "Instantané multiple",
      "Sujet pluriel",
      "Engrenages posœnnoïaux",
      "Posœnnoïaque",
      "Posœnnoïque",
      "Posœnnomia",
      "Posœnnoïamie",
      "Modalités opératives",
      "Temporalité élargie",
      "Temporalité éclatée"
    ].forEach(function (term) {
      uniqPush(merged, term);
    });

    return merged;
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    return new RegExp(parts.join("|"), "g");
  }

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";
    var rx = buildProtectMatcher();
    return src.replace(rx, function (m) {
      return '<span translate="no" class="po-lex-protect">' + m + "</span>";
    });
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
    } else {
      el.setAttribute("hidden", "");
    }
  }

  var CONTENT = {
    fr: {
      title: "Katûpirsia 1 — Parcours des quiz",
      kicker: "Portail d’exploration de l’Axis actif : La Posœnnoïa, les Piliers, les Outils et les Engrenages posœnnoïaux.",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Arbre_posoennoial_du_Posoenoisme.png?v=1746299653",
        alt: "Arbre Posœnnoïal - Axis"
      },
      intro_1: "Les quiz de <strong>Katûpirsia 1</strong> proposent une traversée progressive de la structure vibratoire centrale du système : <strong>La Posœnnoïa</strong>, les <strong>4 Piliers</strong>, les <strong>4 Outils</strong> et les <strong>2 Engrenages</strong>. Ils servent à entrer dans l’<strong>Organon posœnnoïal</strong> par ses seuils fondamentaux, sans dissocier pensée, perception, souffle et opérativité.",
      intro_2: "Chaque quiz isole un foyer du système pour le rendre lisible, activable et transmissible. L’ensemble forme ainsi un parcours d’initiation structurée : comprendre ce que chaque groupe d’éléments accomplit, puis sentir comment tout fonctionne avec tout à l’intérieur de l’Axis.",
      card_poso_title: "La Posœnnoïa",
      card_poso_body: "<strong>Objectif :</strong> Approcher le fondement vibratoire du système, le verbe-matrice qui met en mouvement l’addition des savoirs, l’accordage des perspectives et l’entrée en opérativité.<br><br><strong>Ce que ce quiz représente :</strong> Le point-source, le foyer génératif, la mise en marche de l’ensemble de l’Axis.",
      card_poso_cta: "Accéder au quiz",
      card_piliers_title: "Les Piliers",
      card_piliers_body: "<strong>Objectif :</strong> Comprendre le socle d’énergie de l’Axis à travers <strong>RéZonans</strong>, <strong>Péroptissimisme</strong>, <strong>Illusion</strong> et <strong>Aliœvolution</strong>.<br><br><strong>Ce que ce quiz représente :</strong> La stabilité dynamique du champ, les lois de modulation qui empêchent le système de s’effondrer sur lui-même.",
      card_piliers_cta: "Accéder au quiz",
      card_outils_title: "Les Outils",
      card_outils_body: "<strong>Objectif :</strong> Explorer les activateurs perceptifs et intégratifs : <strong>Addition synchrêtique</strong>, <strong>Instantané multiple</strong>, <strong>Superposition de perspectives</strong> et <strong>Sujet pluriel</strong>.<br><br><strong>Ce que ce quiz représente :</strong> Les organes de passage qui transforment les flux du sens en matrices opératives lisibles et activables.",
      card_outils_cta: "Accéder au quiz",
      card_engrenages_title: "Les Engrenages",
      card_engrenages_body: "<strong>Objectif :</strong> Saisir la dynamique d’oscillation entre <strong>Posœnnoïaque</strong> et <strong>Posœnnoïque</strong>, c’est-à-dire l’accumulation et l’épure.<br><br><strong>Ce que ce quiz représente :</strong> La respiration interne du système, le moteur qui enrichit, condense, clarifie et maintient la cohérence mouvante de l’<strong>Organon posœnnoïal</strong>.",
      card_engrenages_cta: "Accéder au quiz",
      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Katûpirsia 1 — Quiz pathway",
      kicker: "Portal for exploring the active Axis: Posœnnoïa, the Piliers, the Outils, and the Engrenages posœnnoïaux.",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Arbre_posoennoial_du_Posoenoisme.png?v=1746299653",
        alt: "Arbre Posœnnoïal - Axis"
      },
      intro_1: "The quizzes of <strong>Katûpirsia 1</strong> offer a progressive crossing of the central vibratory structure of the system: <strong>Posœnnoïa</strong>, the <strong>4 Piliers</strong>, the <strong>4 Outils</strong>, and the <strong>2 Engrenages</strong>. They are designed to enter the <strong>Organon posœnnoïal</strong> through its fundamental thresholds, without separating thought, perception, breath, and operativity.",
      intro_2: "Each quiz isolates one core zone of the system in order to make it readable, activable, and transmissible. Together, they form a structured initiation path: understanding what each group of elements does, then sensing how everything functions with everything inside the Axis.",
      card_poso_title: "Posœnnoïa",
      card_poso_body: "<strong>Objective:</strong> Approach the vibratory foundation of the system, the matrix-verb that sets the addition of knowledges, the tuning of perspectives, and the entry into operativity in motion.<br><br><strong>What this quiz represents:</strong> The source-point, the generative center, the ignition of the whole Axis.",
      card_poso_cta: "Open the quiz",
      card_piliers_title: "The Piliers",
      card_piliers_body: "<strong>Objective:</strong> Understand the energetic base of the Axis through <strong>RéZonans</strong>, <strong>Péroptissimisme</strong>, <strong>Illusion</strong>, and <strong>Aliœvolution</strong>.<br><br><strong>What this quiz represents:</strong> The dynamic stability of the field, the laws of modulation that keep the system from collapsing into itself.",
      card_piliers_cta: "Open the quiz",
      card_outils_title: "The Outils",
      card_outils_body: "<strong>Objective:</strong> Explore the perceptive and integrative activators: <strong>Addition synchrêtique</strong>, <strong>Instantané multiple</strong>, <strong>Superposition de perspectives</strong>, and <strong>Sujet pluriel</strong>.<br><br><strong>What this quiz represents:</strong> The organs of passage that transform flows of meaning into operative matrices that can be read and activated.",
      card_outils_cta: "Open the quiz",
      card_engrenages_title: "The Engrenages",
      card_engrenages_body: "<strong>Objective:</strong> Grasp the oscillating dynamic between <strong>Posœnnoïaque</strong> and <strong>Posœnnoïque</strong>, that is, accumulation and distillation.<br><br><strong>What this quiz represents:</strong> The inner respiration of the system, the motor that enriches, condenses, clarifies, and maintains the moving coherence of the <strong>Organon posœnnoïal</strong>.",
      card_engrenages_cta: "Open the quiz",
      cta_translate: "Proposer une traduction du concept"
    },

    es: {
      title: "Katûpirsia 1 — Recorrido de quiz",
      kicker: "Portal de exploración del Axis activo: Posœnnoïa, los Piliers, las Outils y los Engrenages posœnnoïaux.",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Arbre_posoennoial_du_Posoenoisme.png?v=1746299653",
        alt: "Arbre Posœnnoïal - Axis"
      },
      intro_1: "Los quiz de <strong>Katûpirsia 1</strong> proponen una travesía progresiva de la estructura vibratoria central del sistema: <strong>Posœnnoïa</strong>, los <strong>4 Piliers</strong>, las <strong>4 Outils</strong> y los <strong>2 Engrenages</strong>. Sirven para entrar en el <strong>Organon posœnnoïal</strong> por sus umbrales fundamentales, sin separar pensamiento, percepción, aliento y operatividad.",
      intro_2: "Cada quiz aísla un foco del sistema para volverlo legible, activable y transmisible. El conjunto forma así un recorrido de iniciación estructurada: comprender qué realiza cada grupo de elementos y luego sentir cómo todo funciona con todo dentro del Axis.",
      card_poso_title: "Posœnnoïa",
      card_poso_body: "<strong>Objetivo:</strong> Aproximarse al fundamento vibratorio del sistema, el verbo-matriz que pone en movimiento la adición de saberes, el ajuste de perspectivas y la entrada en operatividad.<br><br><strong>Lo que este quiz representa:</strong> El punto-fuente, el foco generativo, la puesta en marcha del conjunto del Axis.",
      card_poso_cta: "Abrir el quiz",
      card_piliers_title: "Los Piliers",
      card_piliers_body: "<strong>Objetivo:</strong> Comprender el zócalo de energía del Axis a través de <strong>RéZonans</strong>, <strong>Péroptissimisme</strong>, <strong>Illusion</strong> y <strong>Aliœvolution</strong>.<br><br><strong>Lo que este quiz representa:</strong> La estabilidad dinámica del campo, las leyes de modulación que impiden que el sistema colapse sobre sí mismo.",
      card_piliers_cta: "Abrir el quiz",
      card_outils_title: "Las Outils",
      card_outils_body: "<strong>Objetivo:</strong> Explorar los activadores perceptivos e integrativos: <strong>Addition synchrêtique</strong>, <strong>Instantané multiple</strong>, <strong>Superposition de perspectives</strong> y <strong>Sujet pluriel</strong>.<br><br><strong>Lo que este quiz representa:</strong> Los órganos de paso que transforman los flujos de sentido en matrices operativas legibles y activables.",
      card_outils_cta: "Abrir el quiz",
      card_engrenages_title: "Los Engrenages",
      card_engrenages_body: "<strong>Objetivo:</strong> Captar la dinámica oscilatoria entre <strong>Posœnnoïaque</strong> y <strong>Posœnnoïque</strong>, es decir, la acumulación y la depuración.<br><br><strong>Lo que este quiz representa:</strong> La respiración interna del sistema, el motor que enriquece, condensa, clarifica y mantiene la coherencia móvil del <strong>Organon posœnnoïal</strong>.",
      card_engrenages_cta: "Abrir el quiz",
      cta_translate: "Proposer une traduction du concept"
    }
  };

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
    }
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;
    setImg(root.querySelector('[data-po-slot="title_img"]'), c.title_img);

    Array.prototype.forEach.call(root.querySelectorAll("[data-po-slot]"), function (el) {
      var key = el.getAttribute("data-po-slot");
      if (!Object.prototype.hasOwnProperty.call(c, key)) return;

      if (key.indexOf("_body") !== -1 || key.indexOf("intro_") === 0) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    var langbar = root.querySelector("[data-po-langbar]");
    if (langbar) {
      langbar.setAttribute("aria-label", (CONTENT[lang] || CONTENT.fr).langbar_aria || "Langue");
    }

    applyLangbar(root, lang);
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || "fr";
    storeLang(safeLang);
    syncDocumentLang(safeLang);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK1QuizPortalInit) return;
    root.__poK1QuizPortalInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    syncDocumentLang(getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  window.PoK1QuizPortalFR_EN_ES_20260321 = {
    init: init,
    getLang: getLang,
    setLang: setLang
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();